import React from "react";
import CompanyBody from "../Body/CompanyBody";

function CompanyProcessList() {
  return (
    <div className="CompanyProcessList">
      <CompanyBody />
    </div>
  );
}

export default CompanyProcessList;
